import Icon from '../components/Icon.vue'

Icon.register({
  undo: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M212.3 224.3H12C5.4 224.3 0 219 0 212.3V12C0 5.4 5.4 0 12 0H60C66.6 0 72 5.4 72 12V90.1C117.8 39.3 184.3 7.5 258.2 8 395.1 9 504.6 119.6 504.3 256.5 504 393.3 393.1 504 256.3 504 192.2 504 133.8 479.7 89.8 439.8 84.7 435.2 84.5 427.2 89.4 422.4L123.3 388.4C127.8 383.9 135 383.7 139.7 387.9 170.8 415.3 211.6 432 256.3 432 353.6 432 432.3 353.3 432.3 256 432.3 158.7 353.6 80 256.3 80 197.8 80 146.1 108.5 114.1 152.3H212.3C219 152.3 224.3 157.7 224.3 164.3V212.3C224.3 219 219 224.3 212.3 224.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/undo.js
// module id = IF7B
// module chunks = 144